import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { Api } from '@brokerage/utils/Api';

export const fetchMobileApps = createAsyncThunk(
  'mobileApps/fetchMobileApps',
  async ({ page = 1, search_term = '' }, { getState, rejectWithValue }) => {
    try {
      const state = getState().mobileApps;

      const cacheKey = search_term ? `${page}_${search_term}` : `${page}`;

      if (state.cache[cacheKey]) {
        return {
          ...state.cache[cacheKey],
          cacheKey,
          currentPage: page,
          searchTerm: search_term,
          fromCache: true
        };
      }

      const params = { per_page: 20, page };

      if (search_term) {
        params.search = search_term;
      }

      const response = await Api.loadMobileApps(params);
      const pagination = JSON.parse(response.headers['x-pagination']);
      const data = response.data;

      return {
        data,
        pagination,
        cacheKey,
        fromCache: false,
        currentPage: page,
        searchTerm: search_term
      };
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to fetch mobile apps');
    }
  }
);

const mobileAppsSlice = createSlice({
  name: 'mobileApps',
  initialState: {
    mobileApps: [],
    pagination: {},
    loading: false,
    error: null,
    cache: {},
    currentPage: 1,
    searchTerm: ''
  },
  reducers: {
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setSearchTerm: (state, action) => {
      state.searchTerm = action.payload;
    },
    clearCache: state => {
      state.cache = {};
    }
  },
  extraReducers: builder => {
    builder
      .addCase(fetchMobileApps.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMobileApps.fulfilled, (state, action) => {
        state.loading = false;
        state.mobileApps = action.payload.data;
        state.pagination = action.payload.pagination;
        state.currentPage = action.payload.currentPage;
        state.searchTerm = action.payload.searchTerm;
        if (!action.payload.fromCache) {
          state.cache[action.payload.cacheKey] = {
            data: action.payload.data,
            pagination: action.payload.pagination
          };
        }
      })
      .addCase(fetchMobileApps.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      });
  }
});

export const { setCurrentPage, setSearchTerm, clearCache } = mobileAppsSlice.actions;
export default mobileAppsSlice.reducer;
